import React, { useState, useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap";

import logoimg from "./img/logo.png"
import library from "./img/library.jpg"

import './App.css';

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function DashBoard() {
  const [ dash, setDash ] = useState([])

  useEffect(() => {
  }, []);

  return (
    <>
      <div>
        <Container>
          <Row>
            <Col md={ 5 } className="intro-container" align="center">
              <div>
                <img className="logo-dash" src={logoimg} />
              </div>
              <br/>
              <div className="section-path" > Bienvenidos al </div>
              <div className="section-title" > INVENTARIO </div>
              <div> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </div>
            </Col>

            <Col md={ 7 } className="img-library-container">
              <div>
                <img className="img-library" src={library} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default DashBoard;
